navigator.getUserMedia =
  navigator.getUserMedia ||
  navigator.webkitGetUserMedia ||
  navigator.mozGetUserMedia ||
  navigator.msGetUserMedia;
var RTCPeerConnection =
  window.RTCPeerConnection ||
  window.webkitRTCPeerConnection ||
  window.mozRTCPeerConnection;
var RTCSessionDescription =
  window.RTCSessionDescription ||
  window.webkitRTCSessionDescription ||
  window.mozRTCSessionDescription;

function getScreenStream() {
  return navigator.mediaDevices
    .getDisplayMedia({
      video: true,
      audio: false
    })
}

function getAudioStream() {
  return navigator.mediaDevices
    .getUserMedia({
      video: false,
      audio: true
    })
}

function closeStream(s) {
  if (s) {
    var tracks = s.getTracks();
    for (var track of tracks) {
      track.stop();
    }
  }
}

export var media = {
  getScreenStream,
  getAudioStream,
  closeStream,
  RTCPeerConnection,
  RTCSessionDescription
}